import React from 'react';
import FormControl, { FormControlProps } from '@mui/material/FormControl';
import { Controller, ControllerProps, FieldError } from "react-hook-form";

import { FormErrorMessage, } from "components/forms";
import TextareaAutosize, { TextareaAutosizeProps } from '@mui/material/TextareaAutosize';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

interface Props {
    name: string;
    rules?: ControllerProps["rules"];
    defaultValue?: any;
    control: ControllerProps["control"];
    error?: FieldError;
    margin?: FormControlProps["margin"];
    containerStyle?: React.CSSProperties;
    formLabel?: string;
    onChangeValue?: (value: string) => void;
}

const TextAreaAutosize = styled(TextareaAutosize)(({ theme }: any) => ({
    padding: 20,
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.common.white,
    borderRadius: 8,
    width: '100%',
    fontSize:16,
    fontFamily: 'Public Sans,sans-serif'
}));

const CustomTextArea = React.memo(((props: Props & TextareaAutosizeProps) => {
    const { margin, name, control, rules, defaultValue, error, containerStyle, formLabel, onChangeValue, ...rest } = props;
    return (
        <FormControl margin={margin} sx={{ width: "100%", alignItems: "flex-start", ...containerStyle }}>
            {formLabel && <Typography variant='body1' marginBottom={1}>{formLabel}</Typography>}
            <Controller
                name={name}
                control={control}
                rules={rules}
                defaultValue={defaultValue ?? null}
                render={({ field: { ref, onChange, ...fieldRest } }) => (
                    <TextAreaAutosize
                        {...fieldRest}
                        {...rest}
                        onChange={e => {
                            onChange(e);
                            if (onChangeValue) {
                                onChangeValue(e.target.value);
                            }
                        }}
                        value={fieldRest.value ?? ""}
                    />
                )}
            />

            <FormErrorMessage error={error} />
        </FormControl>
    )
}));

interface TextAreaState {
    formLabel?: string;
    containerStyle?: React.CSSProperties;
}

const TextArea = React.memo((props: TextareaAutosizeProps & TextAreaState) => {
    const { formLabel, containerStyle, ...rest } = props;

    return (
        <div style={{ ...containerStyle }}>
            {formLabel && <Typography variant='body1' marginBottom={1}>{formLabel}</Typography>}
            <TextAreaAutosize
                {...rest}
                style={{ width: '100%' }}
                value={props.value ?? ""}
            />
        </div>
    )
})

export { CustomTextArea, TextArea };